// extracted by mini-css-extract-plugin
export default {"root":"QuickAccessButtons_root__LGLnO"};